// #1751 · La "versión IA" de la Evolución ya NO se guarda en el navegador.
// Cubre R8 — .claude/specs/1751-copia-ia-paciente/
//
// Hasta #1743 el panel de Evolución guardaba el texto que entregó la IA en
// `localStorage` bajo `turno_llm_baseline.row<_row>.<columna>`: el número de fila
// es REUSABLE (el servidor lo reasigna al paciente siguiente de la cama), sin
// pestaña, médico ni día. Eso dejaba texto clínico en reposo y permitía restaurar
// la evolución del paciente anterior en el actual (familia INC-2026-17 / INC-2026-26,
// ver TranscripcionPanel.jsx:TranscripcionPanel). Ahora la versión IA se lee del
// servidor, que ya filtra por paciente y día.
//
// Las claves que dejó el bundle anterior NO se migran: no hay forma de saber de qué
// paciente son y adoptarlas reabriría el cruce (misma regla que `purgarClavesViejas`
// de turno-draft-buffer.js, memoria turno_draft_buffer_cruce_phi). Se borran.
export const PREFIJO = "turno_llm_baseline.";

export const purgarCopiasIaLocales = () => {
  try {
    const ls = typeof localStorage === "undefined" ? null : localStorage;
    if (!ls) return;
    const claves = [];
    for (let i = 0; i < ls.length; i += 1) {
      const k = ls.key(i);
      if (k && k.startsWith(PREFIJO)) claves.push(k);
    }
    claves.forEach((k) => ls.removeItem(k));
  } catch {
    /* el arranque y el cierre de sesión nunca se bloquean por esta limpieza */
  }
};

// Una vez al cargar el módulo (arranque de la app: authentication-helpers y
// TranscripcionPanel lo importan). Idempotente.
purgarCopiasIaLocales();
